<template>
  <div :class="`entrust-input-survey ${isDialog?'entrust-input-dialog':''}`">
    <p class="title mt-8">人工录入问卷</p>
    <p class="h-5.5 text-medium-x text-theme-black-850 leading-22 text-center mt-4">委托调研工厂专业问卷录入人员进行问卷录入</p>
    <p class="h-5.5 text-medium-x text-theme-black-850 leading-22 text-center mt-2">快速上线问卷，确保问卷质量</p>
    <div class="content">
      <div class="left">
        <p class="h-6 text-large font-semibold text-theme-black-850 leading-24">按年付费会员，可享免费次数</p>
        <div class="flex items">
          <div :class="`item`" v-for="(item, index) in list" :key="index">
            <span :class="`type ${item.className}`">{{item.type}}</span>
            <span class="num">{{item.num}}</span>
          </div>
        </div>
        <p class="text-medium text-theme-black-850 leading-22 mt-4">
          1. 单次录入数量不超过 100 道题，每超 100 题多使用一次免费次数<br/>
          2. 免费次数用尽后，按单次 270 元收费
        </p>
        <p class="text-medium text-theme-black-650 leading-22 mt-6">
          赠送范围不包含以下情况：<br/>
          1. 问卷文件类型为图片或 PDF 格式，不能直接用于问卷录入<br/>
          2. 问卷内容为非中文文本<br/>
          3.问卷包含大量图片、逻辑的，专员仅负责录入文本内容，图片、逻辑需自行处理<br/>
          4. 测评、考试类型问卷，专员负责录入问卷题目，不负责录入测评、考试答案及解析<br/>
          5. 如对上述内容疑问，可扫码联系专员进行人工估价
        </p>
      </div>
      <div class="line"></div>
      <div class="right">
        <p class="font-semibold text-theme-black-850 text-large leading-22">扫码联系问卷专员，沟通问卷录入服务</p>
        <p class="mt-4 text-theme-black-850 text-medium leading-22">
          1. 满足按年付费会员，可享免费录入服务<br/>
          2. 超出免费录入次数时，咨询获取优惠报价<br/>
          3. 图片或 PDF 版本问卷，咨询获取优惠报价<br/>
          4. 复杂问卷（包含英文、测评问卷），咨询获取优惠报价<br/>
          5. 逻辑复杂问卷，咨询获取优惠报价
        </p>
        <img src="/assets/img/code/Mrs.Chai.png"/>
      </div>
    </div>
    <div class="btn" @click="toVersionPrice">购买年会员获取免费问卷录入服务</div>
  </div>
</template>

<script>
import { toVersionPrice } from '@/assets/js/base-platform'

export default {
  name: 'EntrustInputSurvey',
  components: {  },
  props: {
    isDialog: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      list: [
        {type: '免费版', num: '无', className: 'mf'},
        {type: '高级版', num: '6 次', className: 'gj'},
        {type: '尊享版', num: '15 次', className: 'zx'},
        {type: '旗舰版', num: '40 次', className: 'qj'}
      ]
    }
  },
  methods: {
    toVersionPrice
  },

  created() {
  },
  mounted() {
  }
}
</script>

<style scoped lang="scss">
.entrust-input-survey {
  .title {
    font-family: PingFangSC-Medium;
    font-size: 20px;
    @apply h-7 text-center font-semibold text-theme-black-850
  }
  .content {
    width: 853px;
    height: 536px;
    padding-left: 48px;
    @apply flex bg-bg-common-color rounded-small my-0 mx-auto mt-6 py-8 box-border;
    .left {
      width: 329px;
      margin-right: 48px;
      .items {
        @apply rounded-small mt-4;
        .item {
          border: 1px solid #D9D9D9;
          border-right: none;
          font-family: PingFangSC-Medium;
          @apply font-medium text-center;
          .type {
            width: 82px;
            height: 52px;
            line-height: 52px;
            @apply block text-center;
          }
          .num {
            width: 82px;
            height: 52px;
            line-height: 52px;
            font-family: PingFangSC-Regular;
            color: #6B4D3B;
            @apply block text-center text-medium;
          }
        }
        .mf {
          @apply bg-d8 text-theme-black-450;
        }
        .gj {
          background-image: linear-gradient(122deg, #FFE1CD 0%, #FB9446 100%);
          color: #875217;;
        }
        .zx {
          background-image: linear-gradient(-57deg, #FFC051 0%, #FFF3C2 100%, #FFEFD2 100%);
          color: #805D11;
        }
        .qj {
          background-image: linear-gradient(58deg, #464646 0%, #909090 100%);
          color: #F9D1B2;
        }
        & .item:nth-child(4) {
          border-radius: 0 2px 2px 0;
          border-right: 1px solid #D9D9D9;
        }
        & .item:nth-child(1) {
          border-radius: 2px 0 0 2px;
        }
      }
    }
    .line {
      width: 1px;
      height: 472px;
      @apply bg-border-gray;
    }
    .right {
      width: 329px;
      padding-left: 48px;
      img {
        width: 150px;
        height: 150px;
        @apply mt-4;
      }
    }
  }
  .btn {
    width: 256px;
    height: 32px;
    line-height: 32px;
    background: rgb(254, 192, 142);
    color: rgb(139, 102, 77);
    @apply text-center my-0 mx-auto mt-6 mb-8 text-medium cursor-pointer;
  }
}
.entrust-input-dialog {
  .content {
    width: 789px;
    height: 520px;
    @apply pl-8;
    .left {
      width: 331px;
      @apply mr-8;
    }
    .right {
      width: 329px;
      @apply pl-8;
    }
  }
}
</style>
